'use client'

import { ButtonGhost } from 'fukku/Button/Ghost'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'

import { useAnalytics } from '../../contexts/AnalyticsProvider/AnalyticsProvider'
import type { ScrollToAnchorId } from '../../types/ScrollToAnchor'

import styles from './ScrollToAnchor.module.scss'

type ScrollToAnchorProps = {
	id: ScrollToAnchorId
	labelKey: string
	icon?: React.ReactNode
	className?: string
	dataTestId?: string
}

export function ScrollToAnchor({
	id,
	labelKey,
	icon,
	className,
	dataTestId,
}: ScrollToAnchorProps): React.ReactNode {
	const { t } = useLabels()
	const { sendScrollToAnchorEvent } = useAnalytics()

	const onClick = () => {
		const element = document.getElementById(id)
		sendScrollToAnchorEvent({ id })

		if (element) {
			element.scrollIntoView({ behavior: 'smooth', block: 'start' })
		}
	}

	return (
		<ButtonGhost
			data-testid={dataTestId}
			className={cx(styles.button, className)}
			onClick={onClick}
		>
			{icon}
			{t(labelKey)}
		</ButtonGhost>
	)
}
